{
  "Branding_Labels_BrandingEnabled": "Enable Branding for this CME?",
  "Branding_Tab_Name_Colours": "Colours",
  "Branding_Tab_Name_AdditionalColours": "Other Colours",
  "Branding_Tab_Name_Imagery": "Imagery",
  "Branding_Tab_Name_Languages": "Language",
  "Branding_Tab_Name_SSOButtons": "SSO Buttons",
  "Branding_Tab_Name_Links": "Links",
  "Branding_Labels_DarkMode": "(Darkmode)",
  "Branding_Subtitles_ColourPalette": "Colour Palette",
  "Branding_Labels_PrimaryColour": "Primary",
  "Branding_Labels_SecondaryColour": "Secondary",
  "Branding_Labels_TertiaryColour": "Tertiary",
  "Branding_Subtitles_HeaderSidebarColours": "Header/Sidebar Colours",
  "Branding_Labels_HeaderSidebarBackgroundColour": "Header/Sidebar Background",
  "Branding_Labels_HeaderSidebarBackgroundContrastColour": "Header/Sidebar Accent",
  "Branding_Labels_HeaderSidebarIconColour": "Header/Sidebar Icons",
  "Branding_Subtitles_RouterColours": "Router Colours",
  "Branding_Labels_RouterLoaderBackgroundColour": "Router Loader Background",
  "Branding_Labels_RouterLoaderForegroundColour": "Router Loader Foreground",
  "Branding_Subtitles_DashboardColours": "Dashboard Colours",
  "Branding_Labels_Dashboard_1_BgColour": "Dashboard 1 Background",
  "Branding_Labels_Dashboard_1_FgColour": "Dashboard 1 Foreground",
  "Branding_Labels_Dashboard_2_BgColour": "Dashboard 2 Background",
  "Branding_Labels_Dashboard_2_FgColour": "Dashboard 2 Foreground",
  "Branding_Labels_Dashboard_3_BgColour": "Dashboard 3 Background",
  "Branding_Labels_Dashboard_3_FgColour": "Dashboard 3 Foreground",
  "Branding_Labels_Dashboard_4_BgColour": "Dashboard 4 Background",
  "Branding_Labels_Dashboard_4_FgColour": "Dashboard 4 Foreground",
  "Branding_Labels_Dashboard_5_BgColour": "Dashboard 5 Background",
  "Branding_Labels_Dashboard_5_FgColour": "Dashboard 5 Foreground",
  "Branding_Labels_Dashboard_6_BgColour": "Dashboard 6 Background",
  "Branding_Labels_Dashboard_6_FgColour": "Dashboard 6 Foreground",
  "Branding_Subtitles_AuthColours": "Authorisation Colours",
  "Branding_Labels_Auth_Subtitle_HighlightColour": "Authorisation Highlight Colour",
  "Branding_Subtitles_InsightsColours": "Insights Colours",
  "Branding_Labels_Insights_Stat_1_Colour": "Insights Stat 1",
  "Branding_Labels_Insights_Stat_2_Colour": "Insights Stat 2",
  "Branding_Labels_Insights_Stat_3_Colour": "Insights Stat 3",
  "Branding_Labels_Insights_Stat_4_Colour": "Insights Stat 4",
  "Branding_Labels_Insights_Stat_5_Colour": "Insights Stat 5",
  "Branding_Labels_Insights_Percentage_Increase": "Change Indicator - Improvement",
  "Branding_Labels_Insights_Percentage_Decrease": "Change Indicator - Decline",
  "Branding_Labels_Insights_Percentage_NoChange": "No Change Indicator",
  "Branding_Labels_Insights_Quick_BusiestDay": "Insights Busiest Day",
  "Branding_Labels_Insights_Quick_BusiestTime": "Insights Busiest Time",
  "Branding_Labels_Highlights_MostCalled": "Highlights Most Called",
  "Branding_Labels_Highlights_MostAnsweredCalls": "Highlights Most Answered Calls",
  "Branding_Subtitles_CompanyLogos": "Company Logos",
  "Branding_Labels_Imagery_MainLogo": "Main Logo (For on dark background)",
  "Branding_Labels_Imagery_MainLogo_White": "Main Logo (For on white background)",
  "Branding_Labels_Imagery_Favicon": "Favicon (.ico file)",
  "Branding_Labels_Imagery_SquareLogo": "Square Logo",
  "Branding_Labels_Imagery_BroadworksLogo": "Broadworks Logo",
  "Branding_Subtitles_Authorisation": "Authorisation Images",
  "Branding_Labels_Imagery_AuthBg": "Authorisation Background (Image or Video)",
  "Branding_Subtitle_AuthLanguages": "Login Page",
  "Branding_Labels_AuthTitle": "Login Page Subtitle",
  "Branding_Labels_AuthTitle2": "Login Page Subtitle Line 2",
  "Branding_Subtitle_Broadworks": "Broadworks",
  "Branding_Labels_BroadworksName": "Broadworks Name",
  "Branding_Subtitle_SSOButtons": "SSO Buttons",
  "Branding_Labels_SSOIcon": "Icon",
  "Branding_Labels_SSOLabel": "Label",
  "Branding_Labels_SSOUrl": "URL",
  "Branding_Labels_MainSiteLink": "Main Site Link",
  "Branding_Validation_MustBeValidURL": "Must be a valid URL",
  "Branding_SSO_Buttons_Add": "Add SSO Button",
  "Branding_SSO_Buttons_Remove": "Remove SSO Button",
  "Branding_Labels_VanityURL": "URL",
  "Branding_ResetButton": "Reset to previous version",
  "Branding_RestoreCurrentVersion": "Return to current version",
  "Branding_ApplyPreviewButton": "Click to preview",
  "Branding_PreviewButton": "There is a draft version available. Click to preview",
  "Branding_DeletePreview": "Delete Preview",
  "Branding_UndoChanges": "Clear current changes",
  "Branding_Required_Message": "This field is required",
  "Branding_Submission_Line1": "We are generating your branding for you",
  "Branding_Submission_Line2": "This might take a few seconds",
  "Branding_Validation_MaxWordLength": "No single word should exceed {} characters",
  "Branding_Validation_MaxLength": "Should not exceed {} characters",
  "NAME": "BrandingLanguage"
}